import { Backdrop, Box, CircularProgress, SxProps, Theme } from '@mui/material';

export const LoadingOverlay = ({ sx }: { sx?: SxProps<Theme> }) => (
  <Backdrop open sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, ...(sx ?? {}) }}>
    <CircularProgress color="inherit" />
  </Backdrop>
);

export const MountableLoadingOverlay = () => (
  <Box
    sx={{
      position: 'absolute',
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CircularProgress color="inherit" />
  </Box>
);
